import { MutationTree } from 'vuex';
import { ApplicationAttributeState } from './types';

export const mutations: MutationTree<ApplicationAttributeState> = {
  setApplicationAttributes: (state, data) => {
    state.applicationAttributes = data
  },
  setApplicationAttributeItem: (state, data) => {
    state.applicationAttribute = data
  },
}